import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import CloseIcon from '@material-ui/icons/Close';

import SlideTransition from '../../_Shared/Transitions/SlideTransition';
import PowerBIHelper from 'Components/_Shared/PowerBiHelper';

import Select from '../../_Shared/SearchableDropdown';

import EditableDataTable from '../../_Shared/DataTables/EditableDataTable';

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: '1 1 auto',
    },
    flexContent: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    },
    powerbiContainer: {
        marginBottom: theme.spacing.unit * 3,
        display: 'flex',
        flex: '1 1 auto'
    },
});

const powerbi = PowerBIHelper.getService();
const _ = require('lodash');

const reportEmbedTemplate = {
    type: "report", accessToken: '', embedUrl: '', tokenType: 1, permissions: 0, viewMode: 0, id: '', settings:
    {
        filterPaneEnabled: false, navContentPaneEnabled: false
    },
}

class ReportEdit extends React.Component {
    state = {
        loading: true,
        pages: [],
        menuLabel: '',
        menuOrder: 0,
        reportTypeId: ''
    }


    loadPowerBiReport = ref => {
        if (ref !== null && !_.isEqual(this.rootElement, ref)) {
            this.rootElement = ref;
            const { report } = this.props;
            if (report !== null) {
                this.setState({
                    loading: true,
                    pages: report.pages || [],
                    menuLabel: report.menuLabel || '',
                    menuOrder: report.menuOrder || 0,
                    reportTypeId: report.reportTypeId || ''
                }, () => {
                    this.component = powerbi.embed(this.rootElement, Object.assign({}, reportEmbedTemplate, {
                        accessToken: report.accessToken, embedUrl: report.powerBiEmbedUrl, id: report.powerBiReport
                    }));
                    this.component.on('loaded', () => {
                        this.rootElement.children[0].style.border = 'none'
                        this.rootElement.children[0].style.height = 'auto'
                        this.component.getPages().then(pages => {
                            this.setState({
                                loading: false,
                                pages: pages.map((el, index) => {
                                    return { name: el.name, displayName: el.displayName, default: el.isActive, index, visible: true }
                                })
                            });
                        });
                    });
                });
            }
        }
    }
    editPage = (page, index) => {
        this.setState(state => {
            let pages = [...state.pages.filter(x => x.name !== page.name), page];
            return { pages };
        });
    }
    handleInputChange = (name, value) => {
        this.setState({ [name]: value });
    }

    saveReport = () => {
        const { pages, menuLabel, menuOrder, reportTypeId } = this.state;
        const { report, onReportSave } = this.props;
        onReportSave({ id: report.id, version: report.version, status: 'complete', pages, menuLabel, menuOrder, reportTypeId });
    }

    render() {
        const { onClose, classes, reportTypes } = this.props;
        const { loading, pages, menuLabel, menuOrder, reportTypeId } = this.state;
        return (
            <Dialog fullScreen open={true} onClose={onClose} TransitionComponent={SlideTransition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={onClose} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            Edit Report Setup
                        </Typography>
                        <Button color="inherit" onClick={this.saveReport}>
                            Save
                        </Button>
                    </Toolbar>
                </AppBar>
                {
                    loading && <LinearProgress variant="query" color="secondary" />
                }<Toolbar variant="dense" />
                <DialogContent className={classes.flexContent}>
                    <Grid container spacing={16} className={classes.flex}>
                        <Grid item lg={5} className={classes.flexContent}>
                            <div className={classes.powerbiContainer} ref={ref => this.loadPowerBiReport(ref)} />
                            <div>
                                <Select options={[].concat(reportTypes).map(x => ({ label: x.name, value: x.id }))}
                                    value={reportTypeId} name="reportTypeId" label="Report Type" required
                                    onChange={value => this.handleInputChange('reportTypeId', value)} placeholder={"Please select a report type"} />

                                <TextField margin="normal" fullWidth value={menuLabel} onChange={e => this.handleInputChange('menuLabel', e.target.value)} placeholder="Menu Label" label="Menu Label" />
                                <TextField margin="normal" value={menuOrder} label="Menu Order" onChange={e => this.handleInputChange('menuOrder', e.target.value)} type="number" placeholder="Menu Order" />
                            </div>
                        </Grid>
                        <Grid item lg={7}>
                            <EditableDataTable columns={[
                                { label: 'Index', field: 'index' },
                                { label: 'Name', field: 'name', disabled: true },
                                { label: 'Display Name', field: 'displayName' },
                                { label: 'Default', field: 'default', type: 'toggle' },
                                { label: 'Visible', field: 'visible', type: 'toggle' },
                            ]} rows={[].concat(pages)} onEdit={this.editPage}
                            // toggleRowMenu={this.toggleRowMenu}
                            // onElementSelect={this.selectFlight} action={action} onCloseToggleRowMenu={this.closeToggleRowMenu}
                            // onActionClick={this.addFlight} 
                            >
                            </EditableDataTable>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        )
    }
}


export default withStyles(styles)(ReportEdit);


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/Reports/ReportEdit.js